export const closeModal = (selector = ".bs-example-modal-center") => {
    const modalEl = document.querySelector(selector);

    if (modalEl) {
        const modalInstance = window.bootstrap?.Modal.getInstance(modalEl)
            || new window.bootstrap.Modal(modalEl);
        modalInstance.hide();
    }

    document.querySelectorAll(".modal-backdrop").forEach(el => el.remove());
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");
};

// // jQuery version
// export const closeModal = (selector = ".bs-example-modal-center") => {
//     if (window.$) {
//         window.$(selector).modal("hide");
//     }
// };
